var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%",
      display: "block",
      shapeRendering: "auto"
    },
    width: "131px",
    height: "131px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.14204545454545456s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 19,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.2840909090909091s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.9943181818181818s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.42613636363636365s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 61,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.8522727272727273s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 61,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.7102272727272727s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61,
    width: 20,
    height: 20,
    fill: "#303e67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#1761fd;#303e67;#303e67",
    keyTimes: "0;0.125;1",
    dur: "1.1363636363636365s",
    repeatCount: "indefinite",
    begin: "0.5681818181818182s",
    calcMode: "discrete"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2e26cfdbb970a3c90ee4f3ef943d66de.svg";
export { ForwardRef as ReactComponent };